import { Icon } from "@/components/ui/icon";
import { Menu, MenuItem, MenuItemLabel } from "@/components/ui/menu";
import { InterfaceMenuProps } from "@gluestack-ui/menu/lib/types";
import { Edit, QrCode } from "lucide-react-native";

export function RestaurantMoreMenu({
  onClose,
  onShowQrs,
  onEditName,
  ...rest
}: InterfaceMenuProps & {
  onEditName: () => void;
  onShowQrs: () => void;
}) {
  return (
    <>
      <Menu placement="bottom" offset={5} onClose={onClose} {...rest}>
        <MenuItem key="Edit" textValue="Edit name" onPress={onEditName}>
          <Icon as={Edit} size={20} className="mr-2" />
          <MenuItemLabel size="sm">Edit name</MenuItemLabel>
        </MenuItem>
        <MenuItem key="qr" textValue="Show QR code" onPress={onShowQrs}>
          <Icon as={QrCode} size={20} className="mr-2" />
          <MenuItemLabel size="sm">Show QR code</MenuItemLabel>
        </MenuItem>
      </Menu>
    </>
  );
}
